import React, { Component } from 'react';
import Overview from './Overview';
import Form from './Form';
import {Switch, Route } from 'react-router-dom';
import {withRouter} from 'react-router';
import { connect } from 'react-redux'

class FileMetaData extends Component {	
  
	render() { 			
        return (
            <Switch>
                <Route exact path="/filemetadatacategory/view" name="Overview" render={(location) => <Overview />}/>  
                <Route exact path="*/filemetadatacategory/update/:categoryId" name="Form" render={(location) => <Form />}/>            
              </Switch>
        )
  	}
}

function mapStateToProps(state, ownProps) {

    return {
        clientData: state.ClientDataReducer, 
        searchData: state.SearchDataReducer       
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchData: (data) => dispatch(setSearchData(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FileMetaData)



// WEBPACK FOOTER //
// ./src/views/Filemetadatacategory/index.js